import React from 'react';
import { Outlet } from 'react-router-dom';
import { PartnerAuthProvider } from '../../contexts/PartnerAuthContext';

const PartnerPortalShell = () => (
  <PartnerAuthProvider>
    <Outlet />
  </PartnerAuthProvider>
);

export default PartnerPortalShell;
